import IUIStore, {UIStoreTypes, SetLeftRail, UIStoreActionType, UIStoreActions, UIStoreState} from './types';
import UIStore from './store';

// singleton
export default new UIStore();
export {IUIStore, UIStoreTypes, SetLeftRail, UIStoreActionType, UIStoreActions, UIStoreState};
